exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-component='rename-your-account'] .content {\n  transform-origin: top;\n}\n[data-component='rename-your-account'] .steps-container {\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n  perspective: 500px;\n  margin: 0 0 40px;\n}\n[data-component='rename-your-account'] .step {\n  top: 0;\n  left: 150%;\n  position: absolute;\n  width: 100%;\n}\n[data-component='rename-your-account'] .buttons {\n  margin: 40px 0 0;\n}\n[data-component='rename-your-account'] [data-component='step-buttons'] .btn {\n  width: 200px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/rename-your-account/rename-your-account.component.styl
// module id = ../../../../../src/app/master/rename-your-account/rename-your-account.component.styl
// module chunks = main